import React, {Component} from 'react';
import config from 'react-global-configuration';
import axios from "axios";
import {Nav, Navbar, NavItem} from "react-bootstrap";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
import ReactTooltip from 'react-tooltip';
import {Link} from 'react-router-dom';
import Switch from "react-switch";
import jwt_decode from "jwt-decode";
import CommonNavbar, {navbar} from "./commonNavbar";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import { Collapse, Button, Input, Form, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class NewBrandViewer extends Component {
    constructor(props){
        super(props);
        this.state = {
            isSubmit: false,
            //loading: false,
            file_name: null,
            brand_files : [],
            brandData: {
                id: '',
                user_id: '',
                file_name: '',
                file_path: '',
                timestamp: '',
                version: '',
                cur_version: '',
                status:'',
                user_type: '',

            },
            brandModel: false,
            data:[],
            raw_display_data: [],
            loading:true,
            _notificationSystem: null,
            versions:[],
            tableLists:[],
            newRelationModel: false,
            relationData: [{ tables:"", columnLists:"", columns:"", id:"", relationToTables:"", toTables:"", toColumnLists:"", toColumns:"" }],
            deleteKeys:[],
            changedItems:[],
            emiMenus:[],
            file_name_display: null,
            activer:[],
            activer2: [],
            activer_freeemi:[],
            activer2_freeemi: [],
            deleter: [],
            campaignDeconfirmationModel: false,
            product_id: null,
            product_brand: null,
            product_category: null,
            product_model_name: null,
            product_model_number: null,
            product_model_description: null,
            product_level_1: null,
            product_level_2: null,
            product_level_3: null,
            product_level_4: null,
            product_model_image_link: null,
            product_product_code: null,
            product_sku: null,
            product_sku_copy: null,
            product_ean: null,
            product_mop: null,
            product_mrp: null,
            product_party_master_id: null,
            is_disable: false,
            canUpdatePrice: false,
            product_effective_date: null,
        }

    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount() {
        const canUpdatePrice =  this.canUpdatePrice();
        this.setState({
            canUpdatePrice: canUpdatePrice
        });
        this.getFileName();
        console.log(this.props.match.params);
        this._refreshBrand_View();
        this.setState({
            _notificationSystem: this.refs.notificationSystem,
            file_name: this.props.match.params.id


        });
        var _notificationSystem = this.refs.notificationSystem;
    }

        // ============ FIXED: canUpdatePrice Method ============
    canUpdatePrice = () => {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        console.log("Decoded user ID:", decoded._id);
        // List of user IDs who can stop promotions
        const allowedUsers = process.env.REACT_APP_ALLOWED_USER_PRICE_UPDATE;
        console.log("Allowed users:", allowedUsers);
        return allowedUsers.includes(decoded._id);
    }

    showUnauthorizedPopup = (actionName) => {
        this.handleNotificationClick("tr", 3, `You are not authorized to perform "${actionName}". Please contact your administrator.`);
    }


    brandData(id, user_id, file_name, file_path, timestamp, version, cur_version, status, user_type) {
        this.setState({
            brandData: {
                id,
                user_id,
                file_name,
                file_path,
                timestamp,
                version,
                cur_version,
                status,
                user_type
            },
            brandModel: !this.state.brandModel
            //login_type:loginType
        });
        this._RawData(user_id, file_name, timestamp)
        //this.findGroups(userType);
        //this.findAccessKeys(id);
    }

    togglebrandModel() {
        this.setState({
            brandModel: !this.state.brandModel
        })
    }

    changeStatus(id, checked) {
        //let status = 0;
        //if(checked===true){ status = 1 } else { status = 0 }
        this.setState({
            activer2: {...this.state.activer2, [id]:checked },
            activer: {...this.state.activer, [id]:checked }
        })
    }

    changeStatusFreeEmi(id, checked) {
        //let status = 0;
        //if(checked===true){ status = 1 } else { status = 0 }
        this.setState({
            activer2_freeemi: {...this.state.activer2_freeemi, [id]:checked },
            activer_freeemi: {...this.state.activer_freeemi, [id]:checked }
        })
    }

    changeDeleteStatus(id, valuer) {
        // console.log(id);
        // console.log(checked);
        this.setState({
            deleter: {...this.state.deleter, [id]:valuer.target.checked }
        })
    }

    activeHandler() {
        if (!this.state.canUpdatePrice) {
            this.showUnauthorizedPopup("Activate/Deactivate Products");
            return;
        }
        this.setState({
            isSubmit: true,
            loading: true
        });
        if(this.state.activer2.length == 0 || this.state.activer2.length == 'undefined'){
            this.handleNotificationClick("tr", 3, "No changes applicable");
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
        }
        else{
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // console.log(decoded);
        const data1 = new FormData();
        data1.append('file_id', this.props.match.params.id);
        data1.append('mappings', JSON.stringify(this.state.activer2));
        data1.append('userGroup', decoded.userGroup);
        console.log(data1);
        axios.post(config.get('API_URL') + "/brandemi/product_master_active_inactive_new", data1,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then(res => {
                console.log(res);
                if(res.data.success){
                    this.handleNotificationClick("tr", 1, 'Record has been updated successfully');
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
                    this._refreshBrand_View();
                }
                else {
                    this.handleNotificationClick("tr", 3, res.data.error);
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
                }
            })
            .catch(err => { // then print response status
                this.handleNotificationClick("tr", 3, "Something Wrong!");
                this.setState({
                    isSubmit:false,
                    loading:false
                })
            })

        }

    }

    activeFreeEmiHandler() {
        if (!this.state.canUpdatePrice) {
            this.showUnauthorizedPopup("Activate/Deactivate Free EMI Products");
            return;
        }
        this.setState({
            isSubmit: true,
            loading: true,
            is_disable: true
        });
        if(this.state.activer2_freeemi.length == 0 || this.state.activer2_freeemi.length == 'undefined'){
            this.handleNotificationClick("tr", 3, "No changes applicable");
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
        }
        else{
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // console.log(decoded);
        const data1 = new FormData();
        data1.append('file_id', this.props.match.params.id);
        data1.append('mappings', JSON.stringify(this.state.activer2_freeemi));
        data1.append('userGroup', decoded.userGroup);
        console.log(data1);
        axios.post(config.get('API_URL') + "/brandemi/product_master_active_inactive_freeemi_new", data1,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then(res => {
                console.log(res);
                if(res.data.success){
                    this.handleNotificationClick("tr", 1, 'Record has been updated successfully');
                    this.setState({
                        isSubmit:false,
                        loading:false,
                        is_disable:false,
                        activer2_freeemi: []
                    });
                    this._refreshBrand_View();
                }
                else {
                    this.handleNotificationClick("tr", 3, res.data.error);
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
                }
            })
            .catch(err => { // then print response status
                this.handleNotificationClick("tr", 3, "Something Wrong!");
                this.setState({
                    isSubmit:false,
                    loading:false
                })
            })

        }

    }

    openDeactivateConfirmation = (id, status) => {
        this.setState({
            mapFieldCampaign: status,
            campaignDeconfirmationModel: !this.state.campaignDeconfirmationModel
        });
    }

    toggleDecampaignModel() {
        this.setState({
            campaignDeconfirmationModel: !this.state.campaignDeconfirmationModel
        });
    }

    openDecampaignModel(id, brand, category, model_name, model_number, model_description, level_1, level_2, level_3, level_4, model_image_link, product_code, sku, ean, mop, mrp, party_master_id) {

        const today = new Date();
        const pad = n => String(n).padStart(2, '0');
        const todayStr = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;

        this.setState({
            product_id: id,
            product_brand: brand,
            product_category: category,
            product_model_name: model_name,
            product_model_number: model_number,
            product_model_description: model_description,
            product_level_1: level_1,
            product_level_2: level_2,
            product_level_3: level_3,
            product_level_4: level_4,
            product_model_image_link: model_image_link,
            product_product_code: product_code,
            product_sku: sku,
            product_sku_copy: sku,
            product_ean: ean,
            product_mop: mop,
            product_mrp: mrp,
            product_party_master_id: party_master_id,
            product_effective_date: todayStr,
            campaignDeconfirmationModel: true,
        });
    }

    activeDeleteHandler() {
        if (!this.state.canUpdatePrice) {
            this.showUnauthorizedPopup("Delete Products");
            return;
        }

        const params = new URLSearchParams(this.props.location.search);

        const file_id = decodeURIComponent(params.get('id') || '');
        this.setState({
            isSubmit: true,
            loading: true
        });


        if(this.state.deleter.length == 0 || this.state.deleter.length == 'undefined'){
            this.handleNotificationClick("tr", 3, "No changes applicable");
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
        }
        else{
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // console.log(decoded);
        const data1 = new FormData();
        data1.append('file_id', file_id);
        data1.append('mappings', JSON.stringify(this.state.deleter));
        data1.append('userGroup', decoded.userGroup);
        console.log(data1);
        axios.post(config.get('API_URL') + "/brandemi/product_master_delete_new", data1,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then(res => {
                console.log(res);
                if(res.data.success){
                    this.handleNotificationClick("tr", 1, 'Record has been updated successfully');
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
                    this._refreshBrand_View();
                    //this.props.history.push('/admin/brand-product-master')
                }
                else {
                    this.handleNotificationClick("tr", 3, res.data.error);
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
                }
            })
            .catch(err => { // then print response status
                this.handleNotificationClick("tr", 3, "Something Wrong!");
                this.setState({
                    isSubmit:false,
                    loading:false
                })
            })

        }

    }


    editProduct() {
        if (!this.state.canUpdatePrice) {
            this.showUnauthorizedPopup("Edit Product");
            return;
        }

        this.setState({
            isSubmit: true,
            loading: true
        });
        let ider = this.props.match.params.id;
        let kill = 0;
        // if(this.state.product_brand == null || this.state.product_brand == ''){
        //     this.handleNotificationClick("tr", 3, "Brand required");
        //     kill = 1;
        // }
        // else if(this.state.product_category == null || this.state.product_category == ''){
        //     this.handleNotificationClick("tr", 3, "Category required");
        //     kill = 1;
        // }
        // else if(this.state.product_model_number == null || this.state.product_model_number == ''){
        //     this.handleNotificationClick("tr", 3, "Model number required");
        //     kill = 1;
        // }
         //if(this.state.product_model_name == null || this.state.product_model_name == ''){
        //     this.handleNotificationClick("tr", 3, "Model name required");
        //     kill = 1;
        // }

        // else if(this.state.product_sku == null || this.state.product_sku == ''){
        //     this.handleNotificationClick("tr", 3, "SKU required");
        //     kill = 1;
        // }
        if(this.state.product_mop == null || this.state.product_mop == '' || isNaN(this.state.product_mop) || Number(this.state.product_mop) < 1 || Number(this.state.product_mop) > Number(this.state.product_mrp)){
            this.handleNotificationClick("tr", 3, "Invalid MOP");
            kill = 1;
        }
        else if(this.state.product_mrp == null || this.state.product_mrp == '' || isNaN(this.state.product_mrp) || Number(this.state.product_mrp) < 1){
            this.handleNotificationClick("tr", 3, "Invalid MRP");
            kill = 1;
        }
        else if(this.state.product_model_name == null || String(this.state.product_model_name).trim() == ''){
            this.handleNotificationClick("tr", 3, "Model name required");
            kill = 1;
        }
        if (kill == 0){
            const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // console.log(decoded);
        const data1 = new FormData();
        data1.append('id', this.state.product_id);
        // data1.append('brand', this.state.product_brand);
        // data1.append('category', this.state.product_category);
        // data1.append('model_name', this.state.product_model_name);
        // data1.append('model_number', this.state.product_model_number);
        // data1.append('model_description', this.state.product_model_description);
        data1.append('level_1', this.state.product_level_1);
        // data1.append('level_2', this.state.product_level_2);
        // data1.append('level_3', this.state.product_level_3);
        // data1.append('level_4', this.state.product_level_4);
        // data1.append('model_image_link', this.state.product_model_image_link);
        // data1.append('product_code', this.state.product_product_code);
        data1.append('sku', this.state.product_product_code);
        // data1.append('ean', this.state.product_ean);
        data1.append('mop', this.state.product_mop);
        data1.append('mrp', this.state.product_mrp);
        data1.append('party_master_id', this.state.product_party_master_id);
        data1.append('effective_date', this.state.product_effective_date);
        console.log(data1);
        axios.post(config.get('API_URL') + "/brandemi/product_master_update_mrp", data1,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then(res => {
                console.log(res);
                if (res.data.flag == '-1'){
                    this.handleNotificationClick("tr", 3, "SKU already exists.");
                }
                else if (res.data.flag == '1'){
                    this.handleNotificationClick("tr", 1, "Product Updated");
                    this._refreshBrand_View();
                    this.toggleDecampaignModel();
                    //console.log(url);
                    //this.props.history.push(url)
                }
                else if (res.data.flag == '0'){
                    this.handleNotificationClick("tr", 3, "Something Wrong");
                }
                else if (res.data.flag == '2'){
                    this.handleNotificationClick("tr", 3, "Failure");
                }
                else if (res.data.flag == '4'){
                    this.handleNotificationClick("tr", 2, "Sparcs DB Updated");
                    this._refreshBrand_View();
                    this.toggleDecampaignModel();
                }
                else if (res.data.flag == '6'){
                    this.handleNotificationClick("tr", 3, "Similar model name exists for other SKU");
                    this.toggleDecampaignModel();
                }else{
                    this.props.history.push("/admin/admin-upload-products");
                }
            })
            .catch(err => { // then print response status
                this.handleNotificationClick("tr", 3, "Something Wrong!");
                this.setState({
                    isSubmit:false,
                    loading:false
                })
            })
        }
        this.setState({
            loading: false
        });

    }

    getFileName(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        console.log(decoded);
        axios.get(config.get('API_URL') + '/brandemi/get_file_name',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                file_id: this.props.match.params.id
            }
        }).then(response => {
            let file_name_to_display = response.data;
            this.setState({
                file_name_display: file_name_to_display[0].file_name
            })
        });
    }

    _refreshBrand_View() {
        if ($.fn.DataTable.isDataTable('#brandViewTable')) {
            $('#brandViewTable').DataTable().destroy();
        }
        const queryParams = new URLSearchParams(this.props.location.search);
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        console.log(decoded);
        const file_id = decodeURIComponent(queryParams.get('id') || '');
        const sku = localStorage.getItem('skuData') || '';

        console.log(sku);
        console.log("📦 DEBUG SKU:", sku, typeof sku);
        console.log("📁 DEBUG file_id:", file_id, typeof file_id);
        axios.get(config.get('API_URL') + '/brandemi/view_brand_sku_id_new',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                file_id: file_id,
                sku: sku
            }
        }).then(response => {
            console.log(response.data);
            response.data.data.map((value, index) => {
                var status = false;
                var status2 = false;
                if(value.isActive===true) { status = true;}
                if(value.isFreeEMI===true) { status2 = true;}
                this.setState({
                    activer: {...this.state.activer, [value.brandSkuCode]:status },
                    activer_freeemi: {...this.state.activer_freeemi, [value.brandSkuCode]:status2 }
                });
            });
            this.setState({
            raw_display_data: response.data.data,
            productData: response.data.data // <-- THIS LINE ADDED
             });
            this.setState({
                raw_display_data: response.data.data
            });
            $('#brandViewTable').DataTable({
                "oLanguage": {
                    "sEmptyTable": "No data exists for this file"
                }
            });
            this.setState({
                loading: false
            });
            //this.preAppender();

        });
    }


    handleChange(id, e) {
        console.log(id);
        console.log(e.target.value);
        this.setState({
            changedItems: {...this.state.changedItems, [id]:e.target.value},
            isChange: true
        });
    }


    render() {

        // console.log(this.state.deleter);
        //console.log(this.state.relationData);

        const {canUpdatePrice} = this.state;
        let brand_data = this.state.raw_display_data.map((value,index) => {
            // if(value.editable == "1"){
                return (
                    <tr key={index + 1}>
                    <td><Checkbox number={value.brandSkuCode} id={value.brandSkuCode} onChange={this.changeDeleteStatus.bind(this, value.brandSkuCode)} checked={(this.state.deleter[value.brandSkuCode])? true : false} /></td>
                    <td>{value.brand}</td>
                    <td>{value.category}</td>
                    <td>{value.modelName}</td>
                    <td>{value.model_number}</td>
                    <td>{value.modelDescription + '  ' + value.level1 + '  ' + value.level2 + '  ' + value.level3 + '  ' + value.level4}</td>
                    <td>{value.sku}</td>
                    <td>{value.mrp}</td>
                    <td>{value.mop}</td>
                    <td>
                        <Switch className="react-switch" height={20} width={38} id={String(value.brandSkuCode)} onChange={this.changeStatus.bind(this, value.brandSkuCode)} checked={(this.state.activer[value.brandSkuCode])? true : false}></Switch>
                    </td>
                    <td>
                        <Switch className="react-switch" disabled={value.freeemi == 1} height={20} width={38} id={value.isFreeEMI} onChange={this.changeStatusFreeEmi.bind(this, value.brandSkuCode)} checked={(this.state.activer_freeemi[value.brandSkuCode])? true : false}></Switch>
                    </td>
                    <td>
                        <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
                        <Link className="viewButton" data-tip="Edit Product" onClick={this.openDecampaignModel.bind(this, value.id, value.brand, value.category, value.modelName, '', value.modelDescription, value.level1, value.level2, value.level3, value.level4, value.model_image_link, value.brandSkuCode, value.sku, value.ean, value.mop, value.mrp, value.party_master_id)}><span className="glyphicon glyphicon-edit" aria-hidden="true"></span></Link>
                    </td>
                </tr>
                )
            //}
            // else{
            //     return (
            //         <tr key={index + 1}>
            //         <td><Checkbox number={value.id} disabled={true} id={value.id} onChange={this.changeDeleteStatus.bind(this, value.id)} checked={(this.state.deleter[value.id])? true : false} /></td>
            //         <td>{value.brand}</td>
            //         <td>{value.category}</td>
            //         <td>{value.model_name}</td>
            //         <td>{value.model_number}</td>
            //         <td>{value.model_description}</td>
            //         <td>{value.sku}</td>
            //         <td>{value.mrp}</td>
            //         <td>{value.mop}</td>
            //         <td>
            //             <Switch className="react-switch" disabled={true} height={20} width={38} id={value.id} onChange={this.changeStatus.bind(this, value.id)} checked={(this.state.activer[value.id])? true : false}></Switch>
            //         </td>
            //         <td>
            //             <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
            //             <Link className="viewButton" data-tip="Can't edit as product is active in promotions"><span className="glyphicon glyphicon-edit" aria-hidden="true"></span></Link>
            //         </td>
            //     </tr>
            //     )
            // }
        });

        return(
        <div className="longcontent">
            <CommonNavbar/>
            <div className="container-fluid">
            <Modal isOpen={this.state.campaignDeconfirmationModel}
                toggle={this.toggleDecampaignModel.bind(this)}
                size = "lg"
                >
                <ModalBody>
                    <div className="row">
                        <div className="col-xs-12 ">
                            <h4 className="modalh4">Edit Product: {this.state.product_sku_copy}</h4>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <Label>Brand:</Label>
                                <Input id="product_brand" disabled={true} className="maxheighter" value={this.state.product_brand} onChange={(e)=> {
                                    let {product_brand} = this.state;
                                    product_brand = e.target.value;
                                    if((e.target.value === '')){
                                        this.handleNotificationClick("tr", 3, "Insert valid brand");
                                    }
                                    this.setState({
                                        product_brand: product_brand
                                    })
                                }}/>
                        </div>
                        <div className="col-md-4">
                            <Label>Category:</Label>
                                <Input id="product_category" disabled={true} className="maxheighter" value={this.state.product_category} onChange={(e)=> {
                                    let {product_category} = this.state;
                                    product_category = e.target.value;
                                    if((e.target.value === '')){
                                        this.handleNotificationClick("tr", 3, "Insert valid category");
                                    }
                                    this.setState({
                                        product_category: product_category
                                    })
                                }}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <Label>Model Number:</Label>
                                <Input id="product_model_number" disabled={true} className="maxheighter" value={this.state.product_model_number} onChange={(e)=> {
                                    let {product_model_number} = this.state;
                                    product_model_number = e.target.value;
                                    if((e.target.value === '')){
                                        this.handleNotificationClick("tr", 3, "Insert valid model number");
                                    }
                                    this.setState({
                                        product_model_number: product_model_number
                                    })
                                }}/>
                        </div>
                        <div className="col-md-4">
                            <Label>Model Name:</Label>
                                <Input id="product_model_name"  className="maxheighter" disabled={true} value={this.state.product_model_name} 
                                // onChange={(e)=> {
                                //     let {product_model_name} = this.state;
                                //     product_model_name = e.target.value;
                                //     if((e.target.value === '')){
                                //         this.handleNotificationClick("tr", 3, "Insert valid reason");
                                //     }
                                //     this.setState({
                                //         product_model_name: product_model_name
                                //     })
                                // }}
                                />
                        </div>
                        <div className="col-md-4">
                            <Label>Model Description:</Label>
                                <Input id="product_model_description" disabled={true} className="maxheighter" value={this.state.product_model_description}
                                //  onChange={(e)=> {
                                //     let {product_model_description} = this.state;
                                //     product_model_description = e.target.value;
                                //     if((e.target.value === '')){
                                //         this.handleNotificationClick("tr", 3, "Insert valid reason");
                                //     }
                                //     this.setState({
                                //         product_model_description: product_model_description
                                //     })
                                // }}
                                />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <Label>Level 1:</Label>
                                <Input id="product_level_1" disabled={true} className="maxheighter" value={this.state.product_level_1} 
                                // onChange={(e)=> {
                                //     let {product_level_1} = this.state;
                                //     product_level_1 = e.target.value;
                                //     if((e.target.value === '')){
                                //         this.handleNotificationClick("tr", 3, "Insert valid level_1");
                                //     }
                                //     this.setState({
                                //         product_level_1: product_level_1
                                //     })
                                // }}
                                />
                        </div>
                        <div className="col-md-4">
                            <Label>Level 2:</Label>
                                <Input id="product_level_2" disabled={true} className="maxheighter" value={this.state.product_level_2} onChange={(e)=> {
                                    let {product_level_2} = this.state;
                                    product_level_2 = e.target.value;
                                    // if((e.target.value === '')){
                                    //     this.handleNotificationClick("tr", 3, "Insert valid reason");
                                    // }
                                    this.setState({
                                        product_level_2: product_level_2
                                    })
                                }}/>
                        </div>
                        <div className="col-md-4">
                            <Label>Level 3:</Label>
                                <Input id="product_level_3" disabled={true} className="maxheighter" value={this.state.product_level_3} onChange={(e)=> {
                                    let {product_level_3} = this.state;
                                    product_level_3 = e.target.value;
                                    // if((e.target.value === '')){
                                    //     this.handleNotificationClick("tr", 3, "Insert valid reason");
                                    // }
                                    this.setState({
                                        product_level_3: product_level_3
                                    })
                                }}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <Label>Level 4:</Label>
                                <Input id="product_level_4" disabled={true} className="maxheighter" value={this.state.product_level_4} onChange={(e)=> {
                                    let {product_level_4} = this.state;
                                    product_level_4 = e.target.value;
                                    // if((e.target.value === '')){
                                    //     this.handleNotificationClick("tr", 3, "Insert valid reason");
                                    // }
                                    this.setState({
                                        product_level_4: product_level_4
                                    })
                                }}/>
                        </div>
                        <div className="col-md-4">
                            <Label>Model Image Link:</Label>
                                <Input id="product_model_image_link" disabled={true} className="maxheighter" value={this.state.product_model_image_link} onChange={(e)=> {
                                    let {product_model_image_link} = this.state;
                                    product_model_image_link = e.target.value;
                                    // if((e.target.value === '')){
                                    //     this.handleNotificationClick("tr", 3, "Insert valid product_model_image_link");
                                    // }
                                    this.setState({
                                        product_model_image_link: product_model_image_link
                                    })
                                }}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <Label>Product Code:</Label>
                                <Input id="product_product_code" disabled={true} className="maxheighter" value={this.state.product_product_code} onChange={(e)=> {
                                    let {product_product_code} = this.state;
                                    product_product_code = e.target.value;
                                    // if((e.target.value === '')){
                                    //     this.handleNotificationClick("tr", 3, "Insert valid reason");
                                    // }
                                    this.setState({
                                        product_product_code: product_product_code
                                    })
                                }}/>
                        </div>
                        <div className="col-md-4">
                            <Label>SKU:</Label>
                                <Input id="product_sku" disabled={true} className="maxheighter" value={this.state.product_sku} onChange={(e)=> {
                                    let {product_sku} = this.state;
                                    product_sku = e.target.value;
                                    if((e.target.value === '')){
                                        this.handleNotificationClick("tr", 3, "Insert valid sku");
                                    }
                                    this.setState({
                                        product_sku: product_sku
                                    })
                                }}/>
                        </div>
                        <div className="col-md-4">
                            <Label>EAN:</Label>
                                <Input id="product_ean" disabled={true} className="maxheighter" value={this.state.product_ean} onChange={(e)=> {
                                    let {product_ean} = this.state;
                                    product_ean = e.target.value;
                                    // if((e.target.value === '')){
                                    //     this.handleNotificationClick("tr", 3, "Insert valid reason");
                                    // }
                                    this.setState({
                                        product_ean: product_ean
                                    })
                                }}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <Label>MOP:</Label>
                                <Input id="product_mop" disabled={!canUpdatePrice} className="maxheighter" value={this.state.product_mop} onChange={(e)=> {
                                    let {product_mop} = this.state;
                                    product_mop = e.target.value;
                                    // if((e.target.value === '')){
                                    //     this.handleNotificationClick("tr", 3, "Insert valid reason");
                                    // }
                                    this.setState({
                                        product_mop: product_mop
                                    })
                                }}/>
                        </div>
                        <div className="col-md-4">
                            <Label>MRP:</Label>
                                <Input id="product_mrp" disabled={!canUpdatePrice} className="maxheighter" value={this.state.product_mrp} onChange={(e)=> {
                                    let {product_mrp} = this.state;
                                    product_mrp = e.target.value;
                                    if((e.target.value === '') || (isNaN(e.target.value)) || Number(this.state.product_mrp) < 1){
                                        this.handleNotificationClick("tr", 3, "Insert valid mrp");
                                    }
                                    this.setState({
                                        product_mrp: product_mrp
                                    })
                                }}/>
                        </div>
                        <div className="col-md-4">
                            <Label>Effective Date:</Label>
                            <Input
                                id="product_effective_date"
                                type="date"
                                disabled={!canUpdatePrice}
                                className="maxheighter"
                                value={this.state.product_effective_date}
                                min={(() => {
                                    const t = new Date();
                                    const pad = n => String(n).padStart(2, '0');
                                    return `${t.getFullYear()}-${pad(t.getMonth()+1)}-${pad(t.getDate())}`;
                                })()}
                                onChange={(e) => {
                                    this.setState({ product_effective_date: e.target.value });
                                }}
                            />
                        </div>
                    </div>
                    <ModalFooter>
                        {/* {canUpdatePrice && ( */}
                            <Button color="primary"  className="btn btn-primary btn-capitalize" onClick={this.editProduct.bind(this)}>Edit Product</Button>
                        {/* )} */}
                        <Button color="secondary" className="btn-capitalize2" onClick={this.toggleDecampaignModel.bind(this)}>Cancel</Button>
                    </ModalFooter>
                </ModalBody>
            </Modal>
            <div className="card-query-builder top-pad-5">
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip />
                <div className="content">
                    <div className='sweet-loading'>
                        <BeatLoader
                            css={override}
                            sizeUnit={"px"}
                            size={20}
                            color={'#123abc'}
                            loading={this.state.loading}
                        />
                    </div>
                    <div className="pt-5">
                        <div className="card">
                            <div className="header">
                                <h4 className="title">{this.state.file_name_display}</h4>
                            </div>
                            <div className="content notoppadding">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="table-full-width table-responsive">
                                            <table className="table table-striped table-hover" id="brandViewTable">
                                                <thead>
                                                    <tr>
                                                        <th>Delete?</th>
                                                        <th>Brand</th>
                                                        <th>Category</th>
                                                        <th>Model Name</th>
                                                        <th>Model Number</th>
                                                        <th>Model Description</th>
                                                        <th>SKU</th>
                                                        <th>MRP</th>
                                                        <th>MOP</th>
                                                        <th>Active?</th>
                                                        <th>FreeEMI?</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {brand_data}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className ="col-md-12">
                                        {/* {canUpdatePrice && ( */}
                                            <button onClick={this.activeHandler.bind(this)} className="btn btn-primary btn-capitalize pull-right">Update Active</button>,
                                            <button onClick={this.activeFreeEmiHandler.bind(this)} className="btn btn-primary btn-capitalize pull-right" disabled={this.state.is_disable}>Update FreeEmi</button>,
                                            <button onClick={this.activeDeleteHandler.bind(this)} className="btn btn-primary btn-capitalize pull-right">Delete</button>
                                        {/* )} */}
                                        </div>
                                </div>
                            </div>
                            <div className="footer">
                                <div className="stats"><i></i></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            </div>
        );
    }
}
export default NewBrandViewer;